import { AdFrame } from "@/components/AdSlot";

const SAMPLE = `<a href="#" style="display:flex;align-items:center;justify-content:center;gap:14px;width:100%;height:100%;background:linear-gradient(90deg,#3a0d14,#722F37);color:#F3F1EC;font-family:Georgia,serif;text-decoration:none;border-radius:12px;font-size:18px;letter-spacing:1px"><span style="color:#D4AF37;font-style:italic;font-size:24px">Velluto</span> Your sample ad shows here</a>`;

const Frame = ({ label, w, h, code, id }) => (
  <div className="space-y-2">
    <p className="text-[10px] uppercase tracking-[0.2em] text-text-muted">{label} · {w}×{h}</p>
    <div className="overflow-x-auto"><AdFrame code={code} width={w} height={h} fit={false} testId={`ad-preview-${id}`} /></div>
  </div>
);

export function AdPreviews({ code }) {
  const c = code?.trim() ? code : SAMPLE;
  return (
    <div data-testid="ad-previews" className="rounded-2xl border border-white/8 bg-surface p-5 space-y-6">
      <div>
        <p className="text-sm">Ad previews</p>
        <p className="text-[11px] text-text-muted mt-1">{code?.trim() ? "Live render of your banner code." : "Showing a sample. Paste banner code to preview your own ad."}</p>
      </div>
      <Frame label="Desktop leaderboard" w={728} h={90} code={c} id="desktop" />
      <Frame label="Phone banner" w={320} h={100} code={c} id="mobile" />
      <div className="space-y-2">
        <p className="text-[10px] uppercase tracking-[0.2em] text-text-muted">How it sits on Discover</p>
        <div data-testid="ad-preview-discover" className="rounded-xl border border-white/10 bg-ink p-4 space-y-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold">Discover</p>
          <p className="font-display text-2xl">Who's out tonight</p>
          <div className="flex flex-col items-center gap-1">
            <span className="text-[9px] uppercase tracking-[0.3em] text-text-muted">Sponsored</span>
            <div className="w-full overflow-hidden flex justify-center"><AdFrame code={c} width={320} height={100} /></div>
          </div>
          <div className="grid grid-cols-3 gap-2">{[0, 1, 2].map((i) => <div key={i} className="h-20 rounded-lg bg-white/5" />)}</div>
        </div>
      </div>
    </div>
  );
}
